<template>
    <iframe :src="link" frameborder="0" style="width:100%;height:98%"></iframe>
</template>

<script>
export default {
  name: "ifaPage",
  props: ["link"]

}
</script>
